import React from 'react'
import ReactDOM from 'react-dom'
import 'typeface-open-sans'
import 'typeface-saira-extra-condensed'

// CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.css'
import './resume.min.css'
import './index.css'

import App from './App'
import registerServiceWorker from './registerServiceWorker'

// INITIALISE APP
const root = document.getElementById('root')

if (!root) {
  throw new Error('App root is null or undefined.')
}

ReactDOM.render(<App />, root)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js